"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Banner(_ref) {
  var banner = _ref.banner;

  return _react2.default.createElement(
    "div",
    { className: "points-rewards-blue" },
    _react2.default.createElement(
      "a",
      { href: banner.pageUrl, target: "_blank", rel: "noopener noreferrer" },
      _react2.default.createElement(
        "div",
        { className: "top-bar-container wide-page" },
        _react2.default.createElement("img", { alt: "", src: banner.imageWideUrl, className: "top-bar" })
      ),
      _react2.default.createElement(
        "div",
        { className: "top-bar-container narrow-page" },
        _react2.default.createElement("img", { alt: "", src: banner.imageNarrowUrl, className: "top-bar" })
      )
    )
  );
} // Banner

Banner.propTypes = {
  banner: _react.PropTypes.object.isRequired
};

exports.default = Banner;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./src/components/Banner.js
// module id = 1193
// module chunks = 0